export default __webpack_public_path__ + "static/media/3.113f6a71.svg";